import { useEffect, useState } from 'react';

export type UseCountUpOptions = {
    initialValue?: number;
    step?: number;
    speed?: number;
    trigger?: boolean;
};

const useCountUp = (
    target: number,
    { initialValue = 0, step = 5, speed = 1, trigger = true }: UseCountUpOptions = {}
) => {
    const [count, setCount] = useState(initialValue);

    useEffect(() => {
        if (trigger && count < target) {
            setTimeout(() => {
                setCount(prevCount => Math.min(prevCount + step, target));
            }, 1500 / ((target - count) * speed));
        }
    }, [target, trigger, count, speed, step]);

    return count;
};

export default useCountUp;
